/**
 * Created by: Lior Elrom
 * Date: 12/1/15
 * Time: 9:31 AM
 */

'use strict';

var SoaCollection = require('bunsen/collections/SoaCollection');
var InvoiceItems = SoaCollection.extend();

var _ = require('underscore');
var InvoiceItem = require('bunsen/models/ecomm/InvoiceItem');

var getInvoiceItemAmountByType = function (type, currency) {
    var invoiceItems = this.filter(function (item) {
        return item.get('code') === type;
    });

    if (invoiceItems) {
        return _.reduce(invoiceItems, function (memo, item) {
            return memo + (parseFloat(item.getTotalAmount(currency)) || 0);
        }, 0);
    }
    return 0;
};

_.extend(InvoiceItems, {
    TYPE_OFFER_COST: 'OFFER_COST',
    TYPE_OFFER_SALES_TAX: 'OFFER_SALES_TAX',
    TYPE_OFFER_PROMOTION: 'OFFER_PROMOTION',
    TYPE_SHIPMENT_COST: 'SHIPMENT_COST',
    TYPE_SHIPMENT_SALES_TAX: 'SHIPMENT_SALES_TAX',
    TYPE_SHIPMENT_TOTAL_COST: 'SHIPMENT_TOTAL_COST',
    TYPE_DEALER_SHIPMENT_SALES_TAX: 'DEALER_SHIPMENT_SALES_TAX',
    TYPE_FIRSTDIBS_SHIPMENT_SALES_TAX: 'FIRSTDIBS_SHIPMENT_SALES_TAX',
    TYPE_ITEM_PRICE: 'ITEM_PRICE',
    TYPE_PRODUCT_CUSTOMIZATION: 'PRODUCT_CUSTOMIZATION',
    TYPE_ADJUSTMENT_SALES_TAX: 'ADJUSTMENT_SALES_TAX',
    TYPE_CUSTOMER_CHARGE: 'CUSTOMER_CHARGE',
    TYPE_DEALER_SHIPMENT_REFUND: 'DEALER_SHIPMENT_REFUND',
    TYPE_FIRSTDIBS_SHIPMENT_REFUND: 'FIRSTDIBS_SHIPMENT_REFUND',
    TYPE_ITEM_REFUND: 'ITEM_REFUND',
    TYPE_DEALER_REFUND: 'DEALER_REFUND'
});

_.extend(InvoiceItems.prototype, {
    model: InvoiceItem,
    getOfferCost             : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_OFFER_COST),
    getAdjustmentSalesTax    : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_ADJUSTMENT_SALES_TAX),
    getOfferSalesTax         : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_OFFER_SALES_TAX),
    getOfferPromotion        : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_OFFER_PROMOTION),
    getShipmentCost          : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_SHIPMENT_COST),
    getShipmentSalesTax      : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_SHIPMENT_SALES_TAX),
    getShipmentTotalCost     : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_SHIPMENT_TOTAL_COST),
    getItemPriceModification : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_ITEM_PRICE),
    getProductCustomization  : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_PRODUCT_CUSTOMIZATION),
    getCustomerCharge        : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_CUSTOMER_CHARGE),
    getDealerShipmentRefund  : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_DEALER_SHIPMENT_REFUND),
    getFirstDibsShipmentRefund  : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_FIRSTDIBS_SHIPMENT_REFUND),
    getItemRefund            : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_ITEM_REFUND),
    getDealerRefund          : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_DEALER_REFUND)
});

module.exports = InvoiceItems;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/ecomm/InvoiceItems.js
// module id = 160
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55